// JsFromRoutes CacheKey 571497136601c07a6d754feed1945f0b
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  logs: /* #__PURE__ */ definePathHelper('get', '/projects/runs/logs'),
  show: /* #__PURE__ */ definePathHelper('get', '/projects/runs/:id'),
}
